import {HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs";
import {isDefined} from "../libs/utils/epic.utils";

/**
 * Weist jede Anfrage im Electron-Viewer als die des Viewers aus. Das Geheimnis entsteht dort bei jedem
 * Start neu und kommt über `preload.cjs`; fremde Prozesse auf demselben Rechner kennen es nicht.
 *
 * Der Kopf gehört an diese eine Stelle und nicht in die einzelnen Repositories: Der Webserver des
 * Viewers prüft ihn an *beiden* Endpunkten — der SQL-Abfrage und dem Medienabruf —, und der Medienabruf
 * geht über `MediaRepo.loadContent()`, also an `DuckDbHelper.sql()` vorbei. Wer den Kopf pro Aufrufer
 * setzt, vergisst genau den Aufrufer, der die hinterlegten Dokumente ausliefert.
 *
 * Außerhalb des Viewers gibt es kein `electronAPI`; dann bleibt die Anfrage unverändert, damit das
 * Geheimnis nie an den Server der API geht.
 */
export const viewerTokenInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const token: string | undefined = (window as any)?.electronAPI?.sessionToken;
  if (isDefined(token)) {
    return next(request.clone({setHeaders: {'X-Viewer-Token': token}}));
  }
  return next(request);
};
